/** Matches server `approvalGroupDisableMessage.ts` for Preferences UX. */
export const APPROVAL_GROUP_DISABLE_BLOCKED_TITLE =
  'Unable to disable Approvals Group';

/** True when the API rejected disable/remove because the awaiting queue is non-empty. */
export function isApprovalGroupDisableBlockedApiMessage(
  message: string,
): boolean {
  return message.includes("'Awaiting Approval' status");
}

export function approvalGroupDisableBlockedMessage(
  awaitingCount: number,
): string {
  const n = Math.max(0, Math.floor(awaitingCount));
  if (n <= 0) {
    return "Please either approve or reject the requests in 'Awaiting Approval' status.";
  }
  const requestWord = n === 1 ? 'request' : 'requests';
  return `Please either approve or reject the ${n} ${requestWord} in 'Awaiting Approval' status.`;
}
